var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ArticleNameElement from "../../components/articleattributes/articlenameelement.vue";
import ArticleNumberElement from "../../components/articleattributes/articlenumberelement.vue";
import AttachmentsElement from "../../components/articleattributes/attachmentselement.vue";
import CommentElement from "../../components/articleattributes/commentelement.vue";
import CounterSinkingElement from "../../components/articleattributes/countersinkingelement.vue";
import GrindingDropDown from "../../components/articleattributes/grindingdropdown.vue";
import FlipSideUsageElement from "../../components/articleattributes/flipusageelement.vue";
import MaterialElement from "../../components/articleattributes/materialelement.vue";
import MultiplicityElement from "../../components/articleattributes/multiplicityelement.vue";
import RotationDropDown from "../../components/articleattributes/rotationdropdown.vue";
import TappingElement from "../../components/articleattributes/tappingelement.vue";
import TestReportElement from "../../components/articleattributes/testreportelement.vue";
import ThicknessElement from "../../components/articleattributes/thicknesselement.vue";
import ThreadingElement from "../../components/articleattributes/threadingelement.vue";
import TubeElement from "../../components/articleattributes/tubeelement.vue";
import TubeLengthElement from "../../components/articleattributes/tubelengthelement.vue";
let EditDataElement = class EditDataElement extends Vue {
    valueChanged(value) {
        return value;
    }
    get key() { return this.elementData.key; }
    get value() { return this.elementData.value; }
    get disabled() { return this.elementData.disabled; }
};
__decorate([
    Prop({ required: true })
], EditDataElement.prototype, "attachmentsLength", void 0);
__decorate([
    Prop({ required: true })
], EditDataElement.prototype, "elementData", void 0);
__decorate([
    Prop({ required: true })
], EditDataElement.prototype, "errors", void 0);
__decorate([
    Prop({ required: true })
], EditDataElement.prototype, "projectEntry", void 0);
__decorate([
    Prop({ required: true })
], EditDataElement.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], EditDataElement.prototype, "thickness", void 0);
__decorate([
    Emit()
], EditDataElement.prototype, "valueChanged", null);
__decorate([
    Inject()
], EditDataElement.prototype, "i18n", void 0);
EditDataElement = __decorate([
    Component({
        components: {
            ArticleNameElement,
            ArticleNumberElement,
            AttachmentsElement,
            CommentElement,
            CounterSinkingElement,
            GrindingDropDown,
            FlipSideUsageElement,
            MaterialElement,
            MultiplicityElement,
            RotationDropDown,
            TappingElement,
            TestReportElement,
            ThicknessElement,
            ThreadingElement,
            TubeElement,
            TubeLengthElement,
        },
        name: "EditDataElement",
    })
], EditDataElement);
export default EditDataElement;
